import React from 'react';
import PropTypes from 'prop-types';
import { Stack } from '@mui/material';
import Select from 'components/select';
import { useRecoilState } from 'recoil';
import { OrderPayload } from 'pages/myidm/store';
import ProvisioningStyles from 'pages/provisioning/vm/style';
import { endPoints } from 'api/endpoints';
import axios from 'api/request';
import { useMutation } from 'react-query';

const GroupCategory = ({ index }) => {
    const [isTouched, setIsTouched] = React.useState(false);
    const [order, setOrder] = useRecoilState(OrderPayload);
    const [options, setOptions] = React.useState([]);
    const groupCategoriesApi = useMutation(() => axios.get(endPoints.myIdm.groupCategories));

    const currentValue = index !== undefined ? order?.multipleResourceGroups?.[index]?.groupCategory : order?.groupCategory;

    const setGroupCategory = (groupCategory) => {
        const updatedGroups = [...(order?.multipleResourceGroups || [])];
        updatedGroups[index] = {
            ...updatedGroups[index],
            groupCategory,
        };
        setOrder({
            ...order,
            multipleResourceGroups: updatedGroups,
        });
    };

    const handleOnSelectChange = (selected) => {
        setGroupCategory(selected.value);
    };

    const resetOptions = () => {
        setOptions([]);
    };

    React.useEffect(() => {
        if (groupCategoriesApi?.isSuccess) {
            setOptions(
                (groupCategoriesApi?.data?.data || [])?.map((category) => ({
                    label: category?.groupCategoryDisplayName,
                    value: category?.groupCategoryBackendName,
                    data: category,
                }))
            );
        }
    }, [groupCategoriesApi?.isSuccess]);

    React.useEffect(() => {
        resetOptions();
        groupCategoriesApi.mutate();
    }, []);

    React.useEffect(() => {
        if (!currentValue && order?.isTouched) setIsTouched(true);
        else setIsTouched(false);
    }, [currentValue, order?.isTouched]);

    return (
        <Stack direction="row" spacing={1} sx={ProvisioningStyles.stack}>
            <Select
                sx={{ marginTop: 0 }}
                key={`group-category-${index !== undefined ? index : 'single'}`}
                label="Group Category *"
                value={options.find((option) => option.value === currentValue) || null}
                options={options}
                handleOnSelect={(value) => handleOnSelectChange(value)}
                isRequired={isTouched}
                disabled={groupCategoriesApi.isLoading}
                isLoading={groupCategoriesApi.isLoading}
                isOptionEqualToValue={(option, selectedValue) => option.value === selectedValue.value}
            />
        </Stack>
    );
};

GroupCategory.propTypes = {
    index: PropTypes.number,
};

GroupCategory.defaultProps = {
    index: undefined,
};

export default GroupCategory;
